import { Card, CardContent } from "@/components/ui/card";

/**
 * Compact KPI card used in the dashboard stats row.
 * Pass any lucide-react icon as the `icon` prop.
 */
const StatsCard = ({ title, value, subtitle, icon: Icon, trend }) => (
  <Card className="bento-card">
    <CardContent className="pt-4">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm text-muted-foreground">{title}</p>
          <p className="text-2xl font-bold mt-1">{value}</p>
          {subtitle && <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>}
        </div>
        <div
          className={`p-2 rounded-lg ${
            trend === "up" ? "bg-emerald-500/20" : trend === "down" ? "bg-red-500/20" : "bg-zinc-800"
          }`}
        >
          <Icon
            className={`w-5 h-5 ${
              trend === "up" ? "text-emerald-400" : trend === "down" ? "text-red-400" : "text-muted-foreground"
            }`}
          />
        </div>
      </div>
    </CardContent>
  </Card>
);

export default StatsCard;
